import { GraduationCap, Lightbulb, Code, Rocket } from "lucide-react";

const SectionApproche = () => {
    const steps = [
        {
            step: "01",
            title: "Formation",
            description: "Tous niveaux, orientée vers un impact immédiat",
            icon: GraduationCap,
            color: "accent",
        },
        {
            step: "02",
            title: "Cas d'usage",
            description: "Priorisés selon l'impact business",
            icon: Lightbulb,
            color: "success",
        },
        {
            step: "03",
            title: "Développement",
            description: "Agents IA, applications, automatisation",
            icon: Code,
            color: "warning",
        },
        {
            step: "04",
            title: "Déploiement",
            description: "Mise en production et suivi dans la durée",
            icon: Rocket,
            color: "highlight",
        },
    ];

    const colorClasses = {
        accent: 'bg-accent',
        success: 'bg-success',
        warning: 'bg-warning',
        highlight: 'bg-highlight',
    };

    return (
        <div className="container mx-auto mt-14">
            <p className="uppercase text-xs text-accent font-medium before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
                Notre approche
            </p>
            <h3 id="approche-title" data-animate
                className="text-4xl font-bold text-primary text-center mb-20 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
            >
                Une approche complète, orientée résultats
            </h3>
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                {steps.map((item, index) => {
                    const Icon = item.icon;
                    const color = colorClasses[item.color];
                    const isMiddle = index === 0 || index === 3;

                    return (
                        <div key={index} className={`relative text-center group ${isMiddle ? 'lg:mt-6' : ''}`}>
                            <div className="mb-6">
                                <div data-animate
                                    className={`w-14 h-14 mx-auto rounded-full ${color} flex items-center justify-center text-white shadow-lg opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0`}>
                                    <Icon size={24} />
                                </div>
                            </div>

                            <div className="bg-white rounded-2xl shadow-lg p-6 relative z-10 transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-2xl flex flex-col justify-between min-h-[182px]">

                                <h3 data-animate
                                    className="text-lg font-semibold mb-2 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                                    {item.title}
                                </h3>

                                <p  data-animate
                                    className="text-gray-500 text-sm opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                                    {item.description}
                                </p>

                                <div data-animate
                                    className={`mt-6 py-2 rounded-full text-white ${color} text-sm font-medium opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0`}>
                                    Étape {item.step}
                                </div>
                            </div>

                            <div className={`absolute bottom-[-10px] left-6 right-6 h-6 ${color} rounded-full blur-md opacity-50`}></div>

                        </div>
                    );
                })}
            </div>
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4 w-fit mt-11 mx-auto">
                <div className="flex items-start">
                    <svg data-animate className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <p data-animate className="text-green-700 font-medium opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                        Ce qui nous différencie : l’IA devient concrète et opérationnelle
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SectionApproche;
